import ReactDOM from "react-dom";
import ShowAlert from "./WebsiteAlert";
import { IWebsiteAlert } from "./interfaces";
import { getAllUrlParams } from "../../jslibs/urlparams";
import React from "react";
import { getResourceString } from "../../reactcomponents/kentico/resource-strings";

export class WebsiteAlertService {
  static checkAuthenticationErrors() {
    let element = document.getElementsByClassName(
      "website-alert-enabled"
    )[0] as HTMLElement;

    if (typeof element == "undefined" && element == null) {
      return;
    }

    const querystringParams = getAllUrlParams();

    if (querystringParams["authenticationerror"] != "true") {
      return;
    }

    const websiteAlert: IWebsiteAlert = {
      title: `${getResourceString("FNV.Error.Title")}`,
      message:
        `${getResourceString("FNV.Error.Message")}`,
      buttonText: `${getResourceString("FNV.Error.ButtonText")}`,
      defaultOpen: true,
    };

    ReactDOM.render(<ShowAlert {...websiteAlert} />, element);
  }

  static showFormError() {
    const websiteAlert: IWebsiteAlert = {
      title: `${getResourceString("FNV.Error.Title")}`,
      message:
        `${getResourceString("FNV.Error.Message")}`,
      buttonText: `${getResourceString("FNV.Error.ButtonText")}`,
      defaultOpen: true,
    };

    ReactDOM.render(<ShowAlert {...websiteAlert} />, document.body);
  }
}
